<template>
  <div>
    <el-dialog
      :visible.sync="isShow"
      :width="type === 'coach' ? '700px' : '575px'"
      :close-on-click-modal="false"
      custom-class="yioks_alert">
      <div slot="title" class="title">
        <div style="font-size: 25px;font-weight: bold">{{type === 'coach' ? '从教练员管理中选择': '调整球队领队'}}</div>
<!--        <div v-if="type === 'coach'" class="add" @click="addCoach = true">未找到教练？添加教练</div>-->
        <div v-if="type === 'coach'" class="add" @click="coachList()">未找到教练？添加新教练</div>
        <div v-else class="add" @click="addLeader = true">未找到领队？添加领队</div>
      </div>
      <el-form
        v-if="!loading && nameList.length"
        ref="squadForm"
        :model="squadInfo"
        :rules="formRules"
        label-width="100px"
        style="height: 300px"
        class="demo-ruleForm">
        <vue-scroll :ops="ops">
          <el-row v-if="type ==='coach'">
            <el-col :span="9">
              <el-form-item label="主教练" prop="chiefCoachUuid">
                <el-select
                  v-model="squadInfo.chiefCoachUuid"
                  clearable
                  placeholder="请选择主教练"
                  style="width: 100%"
                  @change="adjustCoachList('excuteCoach')" >
                  <el-option
                    v-for="(item, index) in nameList"
                    :key="index"
                    :value="item.uuid"
                    :label="item.idName"
                    :disabled="item.disabled"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
<!--            <el-col :span="9" :offset="1">-->
<!--              <el-form-item label="工作类型" >-->
<!--                <el-select v-model="squadInfo.coachNature" placeholder="请选择工作类型">-->
<!--                  <el-option label="全职" value="full_time"></el-option>-->
<!--                  <el-option label="兼职" value="part_time"></el-option>-->
<!--                </el-select>-->
<!--              </el-form-item>-->
<!--            </el-col>-->
          </el-row>
          <el-row v-if="type ==='coach'">
            <el-form-item label="助理教练" >
              <el-row v-for="(item,index ) in  squadInfo.list "  :key="index" style="margin-bottom: 10px" >
                <el-col :span="19">
                  <el-col :span="10">
                    <el-select v-model="item.coachUuid" placeholder="请选择助理教练"  @change="adjustCoachList('coach', index)">
                      <el-option
                        v-for="(item, index) in nameList"
                        :key="index"
                        :value="item.uuid"
                        :label="item.idName"
                        :disabled="item.disabled"
                      >
                      </el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="12" :offset="1">
                    <el-select v-model="item.duty" placeholder="请选择助理教练职责">
                      <el-option
                        v-for="item in positionList"
                        :key="item.uuid"
                        :label="item.duty"
                        :value="item.duty"
                      >
                      </el-option>
                    </el-select>
                  </el-col>
<!--                  <el-col :span="7" :offset="1">-->
<!--                    <el-select v-model="item.coachNature" placeholder="请选择工作类型">-->
<!--                      <el-option-->
<!--                        label="全职"-->
<!--                        value="full_time">-->
<!--                      </el-option>-->
<!--                      <el-option-->
<!--                        label="兼职"-->
<!--                        value="part_time">-->
<!--                      </el-option>-->
<!--                    </el-select>-->
<!--                  </el-col>-->
                </el-col>
                <el-col :span="4" style="margin-left: 10px">
                  <el-button
                    type="primary"
                    circle
                    icon="el-icon-plus"
                    size="mini"
                    @click="addCoachList(index)"></el-button>
                  <el-button
                    v-if="squadInfo.list.length > 1"
                    type="danger"
                    circle
                    icon="el-icon-minus"
                    size="mini"
                    @click="removeCoachList(index)"></el-button>
                </el-col>
              </el-row>
            </el-form-item>
          </el-row>
          <el-row v-if="type ==='leader'">
            <el-col :span="20">
              <el-form-item label="领队" prop="leaderUuid">
                <el-select v-model="squadInfo.leaderUuid" placeholder="请选择领队" style="width: 100%" >
                  <el-option
                    v-for="(item, index) in leaderList"
                    :key="index"
                    :value="item.uuid"
                    :label="item.idName"
                    :disabled="item.disabled"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </vue-scroll>
      </el-form>
      <div v-if="!loading && !nameList.length" class="add-wrap">
<!--        <div v-if="type ==='coach'">暂时没有教练，<span @click=" addCoach = true;">点击添加教练</span></div>-->
        <div v-if="type ==='coach'">暂时没有教练,<span @click="coachList()">点击添加教练</span></div>
        <div v-else>暂时没有领队，<span @click=" addCoach = true">点击添加领队</span></div>
      </div>
      <div v-if="!loading" class="dialog_btn_wrap" style="height:60px">
        <el-button
          v-show="nameList.length"
          type="primary"
          style="margin-right:20px"
          :loading="addbtnLoading"
          @click="addUser"
        >确认</el-button>
        <el-button v-show="nameList.length" type="danger" @click="isShow = false">取消</el-button>
      </div>
      <yioks-loading v-if="loading" style="height: 360px" />
    </el-dialog>
    <AddCoachDialog
      :defaultSelect="coachInfo"
      :addCoach.sync="addCoach"
      :organList="[]"
      :isEdit="false"
      @hideDialog="(bool) => {addCoach = bool;getSquadInfo()}"></AddCoachDialog>
      <AddLeaderDialog
        :addLeader.sync="addLeader"
        :isEdit="false"
        :leader="{}"
        @hideLeaderDialog="(bool) => {addLeader = bool;getSquadInfo()}" ></AddLeaderDialog>
  </div>
</template>

<script>
import { ops } from '@/utils/scrollIndialog'
import squadFormRule from '@/utils/formRules/squad'
import squad from '@/api/squad'
import storage from '@/utils/storage'
import squadDuty from '@/api/squadDuty'

export default {
  components: {
    'AddCoachDialog': () => import('@/components/coach'),
    'AddLeaderDialog': () => import('@/components/leader')
  },
  mixins: [squadFormRule],
  props: {
    show: {
      type: Boolean,
      required: true
    },
    type: {
      type: String,
      default: 'coach'
    }
  },
  data () {
    return {
      ops,
      loading: false,
      squadInfo: {},
      addbtnLoading: false,
      nameList: [],
      squadUuid: '',
      userRole: '',
      positionList: [],
      // 教练员
      coachInfo: {
        organUuid: '',
        squadUuid: '',
        youthUuid: ''
      },
      addCoach: false,
      organList: [],
      // 领队
      leaderList: [],
      addLeader: false
    }
  },
  computed: {
    isShow: {
      get () {
        return this.show
      },
      set (val) {
        this.$emit('flag', val)
      }
    }
  },
  created () {
    this.squadUuid = this.$route.query.uuid
    this.userRole = storage.get('userInfo').userRole
    if (this.squadUuid) {
      this.getSquadInfo()
    }
    this.getDutyList()
  },
  methods: {
    getSquadInfo () {
      this.loading = true
      squad.getSquadInfo(this.squadUuid).then(res => {
        const { coaches, leaders } = res
        const squadInfo = res.squad
        let list = []
        let masterCoachNature = ''
        coaches.forEach(item => {
          if (!item.master) {
            list.push({
              master: false,
              duty: item.duty,
              coachUuid: item.uuid,
              coachNature: item.coachNature
            })
          } else {
            masterCoachNature = item.coachNature
          }
        })
        if (list.length < 1) list = [{ master: false, duty: '', coachUuid: '' }]
        this.squadInfo = {
          ...squadInfo,
          coachNature: masterCoachNature,
          list
        }
        let request
        if (this.userRole === 'system' || this.userRole === 'admin') {
          request = squad.getCoachListSystem
        } else if (this.userRole === 'organ') {
          request = squad.getCoachListOrgan
        } else if (this.userRole === 'youth' || this.userRole === 'trainCamp' || this.userRole === 'club') {
          request = squad.getCoachListYouth
        }
        request({ youthUuid: squadInfo.youthUuid }).then(res => {
          const { coachOptionVos, leaderOptionVos } = res
          // this.nameList = coachOptionVos.concat(coaches)
          this.nameList = coachOptionVos
          this.nameList = this.nameList.map(item => {
            if (this.squadInfo.chiefCoachUuid === item.uuid || list.some(itm => itm.coachUuid === item.uuid)) {
              item.disabled = true
            } else {
              item.disabled = false
            }
            return item
          })
          this.leaderList = leaderOptionVos.concat(leaders)
          this.loading = false
        })
        this.$set(this.coachInfo, 'organUuid', res.squad.organUuid)
        this.$set(this.coachInfo, 'youthUuid', res.squad.youthUuid)
        this.$set(this.coachInfo, 'squadUuid', res.squad.uuid)
      })
    },
    getDutyList () {
      squadDuty.getAllDuty().then(res => {
        this.positionList = res
      })
    },
    addCoachList () {
      this.squadInfo.list.push({
        coachUuid: '',
        duty: '',
        master: false,
        coachNature: '',
      })
    },
    removeCoachList (index) {
      this.squadInfo.list.splice(index, 1)
      this.adjustCoachList()
    },
    adjustCoachList (type, index) {
      let list = []
      this.squadInfo.list.forEach(item => {
        if (item.coachUuid) list.push(item.coachUuid)
      })
      if (type === 'excuteCoach') {
        this.$set(this.squadInfo,'coachNature', '')
        if (this.squadInfo.chiefCoachUuid){
          this.squadInfo.chiefCoachName = this.nameList.find(item => item.uuid === this.squadInfo.chiefCoachUuid).idName
        }
      }
      if(index) {
        this.squadInfo.list[index].coachNature = '';  // 切换清空工作类型
      }
      this.nameList = this.nameList.map(item => {
        if (this.squadInfo.chiefCoachUuid === item.uuid || list.includes(item.uuid)) {
          item.disabled = true
        } else {
          item.disabled = false
        }
        return item
      })
    },
    addUser () {
      this.$refs['squadForm'].validate(valid => {
        if (valid) {
          // this.addbtnLoading = true
          let coaches = []
          if (this.squadInfo.list[0].coachUuid) {
            this.squadInfo.list.forEach(item => {
              coaches.push({
                ...item,
                squadUuid: this.squadUuid,
                shortName: this.squadInfo.shortName
              })
            })
          }
          if (this.squadInfo.chiefCoachUuid){
            coaches.push({
              coachUuid: this.squadInfo.chiefCoachUuid,
              duty: '主教练',
              master: true,
              squadUuid: this.squadUuid,
              shortName: this.squadInfo.shortName,
              coachNature: this.squadInfo.coachNature
            })
          }

          squad.squadBinding({
            coaches,
            squadUuid: this.squadUuid
          }).then(res => {
            this.addbtnLoading = false
            // 重复处理
            if (res.code) {
              this.$message.error(res.msg)
            } else {
              this.isShow = false
              this.$emit('getList')
            }
          }).catch(err => {
            this.addbtnLoading = false
            console.error(err)
          })
        }
      })
    },
    coachList () {
      this.$router.push({
        path: '/coach/list',
        query: {
          youthUuid: this.coachInfo.youthUuid,
          organUuid: this.coachInfo.organUuid
        }
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
  .add-wrap
    height 300px
    font-size 20px
    line-height 300px
    text-align center
    color #000
    span
      font-weight bold
      font-style italic
      color #4cd964
      cursor pointer
  .title
    color #666
    display flex
    justify-content space-between
    align-items center
    .add
      font-weight bold
      color #4cd964
      cursor pointer
      font-style italic
      font-size 12px
</style>
